import * as Sentry from '@sentry/nextjs'

// Re-export Sentry functions that are used throughout the app
export const captureError = (error: Error, context?: Record<string, any>) => {
  if (process.env.NODE_ENV === 'production') {
    // Add more context to help with debugging
    const enhancedContext = {
      ...context,
      timestamp: new Date().toISOString(),
      location: typeof window !== 'undefined' ? window.location.href : 'server',
    }

    // Capture with enhanced context
    Sentry.captureException(error, { extra: enhancedContext })
  } else {
    console.error('Development mode - Error:', error, 'Context:', context)
  }
}

// This function will be removed after migration
export async function initializeSentry() {
  // Deprecated - Sentry is now initialized via instrumentation.ts
  console.warn('initializeSentry is deprecated - Sentry is now initialized via instrumentation.ts')
}
